module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa27723.woff";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff
// module id = 856
// module chunks = 1